<template>
  <div class="icon-button" @click="$emit('click', $event)">
    <span v-if="$slots.default">
      <slot></slot>
    </span>
    <i :class="[icon, colorTheme]" :style="fontSize" v-if="!fa"/>
    <fa :icon="icon" :class="[colorTheme]" :style="fontSize" v-else/>
  </div>
</template>

<script>
export default {
  name: 'IconButton',
  props: {
    invert: {
      type: Boolean,
      required: false
    },
    icon: {
      type: String,
      required: true
    },
    fa: {
      type: Boolean,
      required: false
    },
    size: {
      type: String,
      required: false
    }
  },
  computed: {
    colorTheme () {
      if (this.invert) {
        return 'button-icon button-icon-invert'
      }

      return 'button-icon'
    },
    fontSize () {
      if (this.size) {
        return { fontSize: this.size + 'px' }
      }

      return {}
    }
  }
}
</script>

<style lang="scss" scoped>

  .icon-button {
    display: flex;
    align-items: center;
    font-size: 12px;
    cursor: pointer;

    span {
      text-transform: none;
      font-weight: 400;
      padding-right: 7px;
    }

    i, svg {
      font-size: 16px;
    }
  }

  .button-icon-invert {
    color: white !important;

    &:hover {
      color: rgba(white, 0.9) !important;
    }
  }

  .button-icon {
    color: #C0C4CC;
    transition: all 0.3s ease;

    &:hover {
      color: #008fcc;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/IconButton.vue